import { memo } from "react";
import PropTypes from "prop-types";
import AmountContainer from "app/pages/.shared/AmountContainer";
import { FormattedMessage } from "react-intl";
import IconInfo from "app/pages/.shared/static/icons/IconInfo";
import FloatingButton from "app/pages/.shared/Popover/FloatingButton";
import { IconCredit } from "app/pages/.shared/static/icons";
import "./TotalCreditBanner.scss";

const TotalCreditBanner = ({ totalCredit }) => {
	if (!totalCredit) {
		return false;
	}
	return (
		<div className="total-credit-banner" data-testid="total-credit-banner">
			<div className="total-credit-banner__content">
				<IconCredit className="total-credit-banner__icon" />
				<FormattedMessage
					id="mycoupons.credit.banner.text"
					values={{
						amount: <AmountContainer amount={totalCredit} />,
					}}
					tagName="div"
				/>
			</div>
			<FloatingButton
				position="bottom"
				floatingContent={
					<div className="total-credit-banner__cgu" data-testid="total-credit-banner-cgu">
						<div className="total-credit-banner__cgu-description">
							<FormattedMessage id="mycoupons.credit.banner.info.description" />
						</div>
					</div>
				}
				popoverClassName="total-credit-banner__cgu-popover"
				referenceComponent={
					<IconInfo
						width={15}
						height={15}
						style={{ marginLeft: "5px" }}
						className="total-credit-banner__cgu-icon"
						data-testid="total-credit-banner-cgu-icon"
					/>
				}
			/>
		</div>
	);
};

TotalCreditBanner.propTypes = {
	totalCredit: PropTypes.any,
};

export default memo(TotalCreditBanner);
